import TopBar from "../../components/layouts/Topbar";
import { Box, Button, Grid, Typography, Stack, TextField, Menu, MenuItem, Divider, SelectChangeEvent } from "@mui/material";
import AggregateCard from "./components/AggregateCard";
import parcel from '../../assets/parcel.png';
import MenuIcon from '@mui/icons-material/Menu';
import DeliveryBoard from "./components/DeliveryBoard";
import RobotIcon from "../../components/icons/RobotIcon";
import RobotStatus from "./components/RobotStatus";
import { cardDetails, mapDetails, generalStatus } from "../../utils/DummyData";
import LocationMarker from "./components/LocationMarker";
import Fuse from "fuse.js";
import JobBoard from "./components/JobBoard";
import { JobEnums } from "../../utils/enums/JobEnums";
import RobotMapContainer from "./components/RobotMapContainer";
import RobotList from "./components/RobotList";
import GeneralStatus from "./components/GeneralStatus";
import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { useWebSocket } from "../../components/useWebSocket";
import axios from "axios";
import { Robot } from "../../components/RobotMap/models/Robot";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';
import salad from '../../../assets/salad.png';
import NotificationHistoryPanel from "./components/NotificationHistoryPanel";
import NotificationPopUp from "./components/NotificationPopUp";
import Sidebar from "../../components/layouts/Sidebar";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { toggle, setTrue, setFalse } from "../../store/deliveryDashboardSlice";
import { storeMapPoints, zoomIn, zoomOut, setPickUpSelected, setDropOffSelected, setSenderLocation, setRecipientLocation, setSenderAndRecipientSelected, setCurrentFloor, resetFloor } from "../../store/map/mapSlice";
import LegendToggleIcon from '@mui/icons-material/LegendToggle';
import { toggleLegend } from "../../store/map/toggleLegendSlice";
import Notification from "./components/Notification";
import FireAlarmModal from "./components/FireAlarmModal";
import { setIsSelectedRobot, setSelectedRobot, updateJobData, updateRobotStatus } from "../../store/robot/robotSlice";
import { setIsJobSelected, setSelectedJob, updateJob } from "../../store/job/jobSlice";
import { updateField, addRecipientLocation, updateRecipientLocation, removeRecipientLocation, setRecipientLocationInForm, updateRecipientIndex, deleteRecipientLocation, callJobAddRecipient } from "../../store/job/formSlice";
import { resetClick, setNotificationHistoryPanel, setNotificationMessage, setNotificationOn, setNotificationTitle, setNotificationType } from "../../store/notification/notificationSlice";
import { setSearchQuery } from "../../store/job/searchSlice";
import { addRobot, updateRobot } from "../../store/robot/robotSlice";
import { MapDetails3, JobData2, JobDetails3, RobotData3, RobotInfo3, FormDataProps } from "../../store/types";
import InfiniteScroll from 'react-infinite-scroll-component';

import { setTotalJobNumber, setTotalPageNumber, setCurrentPageNumber, setJobsPerPage, setCurrentRobotJobsPageNumber, setTotalRobotJobs, setTotalRobotJobsPageNumber } from "../../store/page/jobPageSlice";
import dayjs from "dayjs";
import { API_URL, CLEANING_DIALOG_QUERY_PARAM, CLEANING_MODE_ENABLED, DEFAULT_ROBOT_MODEL, HIDE_DASHBOARD_CARD_KEY, JOB_TYPE, MAP_FLYTO_LAT_QUERY_PARAM, MAP_FLYTO_LNG_QUERY_PARAM, SELECTED_ZONE_QUERY_PARAM, SHOW_ZONE_QUERY_PARAM, TASK_MODE_QUERY_PARAM } from "../../utils/const";
import { useListMap } from "../../hooks/map";
import { MapLevelType } from "../../components/RobotMap/RobotMap";
import { MapType as MapDataType } from "../../hooks/map.type";
import { DEFAULT_LOCATION_LIMIT } from "../../hooks/location";
import { VIEW } from "../../utils/breakpoint";
import { customLog, showErrorToast } from "../../utils/utils";
import { customAxios } from "../../lib/axios";
import { useDisableTabKey } from "../../hooks/keyDown";
import { parseAsArrayOf, parseAsBoolean, parseAsFloat, parseAsString, useQueryState, useQueryStates } from "nuqs";
import { getRobotImage } from "./mock-robots";
import { COLOR } from "../../utils/colors";
import { shadow } from "../../utils/styles";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import { vi } from "date-fns/locale";
import { image } from "html2canvas/dist/types/css/types/image";
import { DashboardMode } from "../../utils/enums/Dashboard";
import CleaningDialog from "./components/CleaningDialog";
import SweepingIcon from "../../assets/cleaning/sweeping-icon.png"
import { parse } from "path";
import CleaningJobBoard from "./components/cleaning/CleaningJobBoard";
import { DataCleaningJobType } from "../../hooks/cleaning/index.type";
import { useDashboardMode } from "../../hooks/appMode";
import { useLocalStorage } from "usehooks-ts";
import { getProfile } from "../../utils/api";
import { useAuth } from "../../context/AuthContext";

interface CardData {
  title: string;
  data: string;
}

interface Pose2 {
  latitude: number;
  longitude: number;
  theta: number;
  z: number;
}

interface MapDetails2 {
  building: string;
  location_name: string;
  map: string;
  map_name: string;
  pose: Pose2;
  store_manager_id: string;
}


interface SearchQuery {
  pickUpResults: MapDetails3[];
  dropOffResults: MapDetails3[];
}


interface JobDetails2 {
  compartment_pin: string;
  id: number;
  job_type: string;
  job_id: number;
  organisation_id: string;
  load_compartment: number;
  recipient_id: string;
  recipient_location: string;
  recipient_name: string;
  robot_id: string;
  sender_id: string;
  sender_location: string;
  sender_name: string;
  timestamp: number;
  order_number: string;
  job_status: string;
  recurring_type: string;
}


interface RobotPose {
  latitude: number;
  longitude: number;
  orientation: number;
}
interface RobotStatus2 {
  battery: number;
  can_assign_job: boolean;
  is_online: boolean;
  map: string;
  map_uuid?: string;
  layout_uuid?: string;
  organisation: string;
  pose: RobotPose;
  robot_id: string;
  robot_state: string;
  robot_type: string;
  timestamp: number;
  robot_name: string;
  robot_serial_number: string;
}


interface GeneralRobotInfo {
  robot_name: string;
  robot_mac: string;
  robot_serial_number: string;
  robot_type: string;
  organisation: string;
  robot_model?: string;
}

export interface RobotInfo {
  robotStatus?: RobotStatus2;
  jobs?: JobData;
  generalInfo: GeneralRobotInfo;
}

export interface RobotsData {
  [robot_id: string]: RobotInfo;
}

interface JobData {
  [order_number: string]: JobDetails2;
}


interface CardDatas {
  title: string;
  data: number;
}

interface Cards {
  [id: string]: CardDatas;
}

const defaultJob: JobDetails2 = {
  compartment_pin: "",
  id: 0,
  job_type: "pick_up_job",
  job_id: 0,
  organisation_id: "",
  load_compartment: 0,
  recipient_id: "",
  recipient_location: "",
  recipient_name: "",
  robot_id: "",
  sender_id: "",
  sender_location: "",
  sender_name: "",
  timestamp: 0,
  order_number: "",
  job_status: "",
  recurring_type: "do_not_repeat"
}

const defaultRobot: RobotInfo = {
  robotStatus: {
    battery: 0,
    can_assign_job: true,
    is_online: true,
    map: "",
    organisation: "",
    pose: {
      latitude: 1.2785387585343386,
      longitude: 103.83483403539259,
      orientation: 0,
    },
    robot_id: "",
    robot_state: "",
    robot_type: "",
    timestamp: 0,
    robot_name: "",
    robot_serial_number: ""
  },
  jobs: {},
  generalInfo: {
    robot_name: "",
    robot_mac: "",
    robot_serial_number: "",
    robot_type: "",
    organisation: "",
    robot_model: DEFAULT_ROBOT_MODEL
  }
};

interface DashboardProps {
  onNotificationCountChange: (count: number) => void;
}

interface CardData {
  title: string;
  data: string;
  id: string;
}

type MapType = {
  building: string,
  map: string,
  map_level?: number,
  map_name?: string
}

const defaultFormValue: FormDataProps = {
  pickUp: "#01-07",
  dropOff: "",
  date: "",
  time: "Pick Up Now",
  pickupOption: "now",
  robot: "Call Nearest Robot",
  phoneNumber: "",

  recipient_name: "",
  recipient_location: "",
  compartment_pin: "0000",
  sender_location: "",
  sender_name: "Kelvin",
  job_type: "pick_up_job", //delivery_job
  //   job_type: "delivery_job",
  // robot_id: "2050E7403412",
  robot_id: "",
  required_compartment: 1,
  timestamp: Date.now(),
  sender_id: "",
  // sender_id: "",
  recipient_id: "",
  recurring_type: "do_not_repeat",
  recurring_days: ["do_not_repeat"],
  organisation_id: ""
}

const availableStatuses = ["idle", "free", "charging"]

const Dashboard: React.FC<DashboardProps> = ({ onNotificationCountChange }) => {
  const currentDropOffIndex = useSelector((state: any) => state.form.current_index);
  const dispatch = useDispatch();
  const isOpen = useSelector((state: any) => state.deliveryDashboard.isOpen);
  const triggerFireState = useSelector((state: any) => state.fire.fireTrigger);
  const isNotificationOn = useSelector((state: any) => state.notification.isNotificationOn);
  const [isLoadingJobs, setIsLoadingJobs] = useState<boolean>(false);
  const [defaultLocation, setDefaultLocation] = useState<MapDetails3>({
    location_name: "",
    map: [],
    pose: {
      latitude: 0,
      longitude: 0,
      theta: 0,
      z: 0
    },
    store_manager_id: ""
  });
  const [isHideCard, setIsHideCard] = useLocalStorage(HIDE_DASHBOARD_CARD_KEY, false)
  const audioSrc = require('../../assets/notificationSound.mp3'); // Make sure the path is correct
  const audioRef = useRef<HTMLAudioElement>(null);
  const [todayJobs, setTodayJobs] = useState<JobData>({});

  const [latestNotificationId, setLatestNotificationId] = useState<string>("");

  const { dashboardMode, isCleaningMode, isDeliveryMode } = useDashboardMode();

  const [isCleaningDialogOpen, setIsCleaningDialogOpen] = useQueryState(CLEANING_DIALOG_QUERY_PARAM, parseAsBoolean.withOptions({
    clearOnDefault: true
  }).withDefault(false));

  const [, setShowZone] = useQueryState(SHOW_ZONE_QUERY_PARAM, parseAsBoolean.withOptions({
    clearOnDefault: true
  }).withDefault(false));

  const [, setSelectedZones] = useQueryState(SELECTED_ZONE_QUERY_PARAM, parseAsArrayOf(parseAsString, ';').withDefault([]))

  useEffect(() => {
    if (!isCleaningDialogOpen) {
      return
    }
    setShowZone(isCleaningDialogOpen);
  }, [isCleaningDialogOpen])

  // const profile = JSON.parse(localStorage.getItem('profile') || '{}');
  const { profile, accessToken } = useAuth();
  // const accessToken = localStorage.getItem('accessToken');
  const [listOfLocations2, setListOfLocations2] = useState<MapDetails3[]>([]);

  const [robots, setRobots] = useState<RobotsData>({});

  const [jobs, setJobs] = useState<JobData>({});
  const [prevRobotPose, setPrevRobotPose] = useState<[number, number]>([0, 0]);
  const [curRobotPose, setCurRobotPose] = useState<[number, number]>([0, 0]);

  const [dummyNotificationHistory, setDummyNotificationHistory] = useState<JobData>({});
  // const { messages, sendMessage } = useWebSocket(`${process.env.REACT_APP_WEBSOCKET_URL}/delivery/overview/${profile.uuid}/`)

  const jobOverviewUrl = `${process.env.REACT_APP_WEBSOCKET_URL}/delivery/overview/${profile.uuid}/`;
  const [notificationCount, setNotificationCount] = useState<number>(0);

  const [cardInfo, setCardInfo] = useState<Cards>({
    totalRobots: { title: "Total Robots", data: 0 },
    idleRobots: { title: "Idle", data: 0 },
    busyRobots: { title: "Busy", data: 0 },
    errorRobots: { title: "Error", data: 0 },
    offlineRobots: { title: "Offline", data: 0 }
  });

  useEffect(() => {
    customLog("checking listoflocation2: ", listOfLocations2);

  }, [listOfLocations2]);

  const handleMessage = useCallback((data: any) => {
    let job = data;
    customLog("Job data:", job);
    // update selectedjob2
    if (selectedJob2 && selectedJob2.order_number === job.order_number) {
      customLog("Updating selected job with new data:", job);
      setSelectedJob2(job);
    }

    // const updateJobs = (jobs: JobData, newJob: JobDetails2) => {
    //     const updatedJobs = {
    //         ...jobs,
    //         [newJob.order_number]: newJob
    //     };
    //     const sortedJobKeys = Object.keys(updatedJobs)
    //         .sort((a, b) => updatedJobs[b].timestamp - updatedJobs[a].timestamp); // Sort by most recent first
    //     if (sortedJobKeys.length > 10) {
    //         sortedJobKeys.length = 10; // Keep only the 10 most recent jobs
    //     }

    //     return sortedJobKeys.slice(0, 10).reduce<JobData>((acc, key) => {
    //         acc[key] = updatedJobs[key];
    //         return acc;
    //     }, {});
    // };

    const updateJobs = (jobs: JobData, newJob: JobDetails2) => {
      const updatedJobs = {
        ...jobs,
        [newJob.order_number]: newJob
      };
      return updatedJobs;
    }

    setJobs(prevJobs => updateJobs(prevJobs, job));
    setTodayJobs(prevJobs => updateJobs(prevJobs, job));

    setRobots(prevRobots => {
      const robotId = job.robot_id;
      const newJobId = job.order_number;
      const newJobData = data;
      customLog("Robot ID:", robotId);
      customLog("Job ID:", newJobId);
      customLog("New Job Data:", newJobData);

      if (robotId in prevRobots) {
        return {
          ...prevRobots,
          [robotId]: {
            ...prevRobots[robotId],
            jobs: {
              ...prevRobots[robotId].jobs,
              [newJobId]: job
            }
          }
        };
      } else {
        return prevRobots;
      }
    });

    dispatch(updateJob({ [job.order_number]: job }));
    if (data.robot_id) {
      dispatch(updateJobData({ [job.order_number]: job }));
    }
  }, []);

  const handleRobotStatus = useCallback((data: any) => {
    // Update robot state
    setRobots(prevRobots => ({
      ...prevRobots,
      [data.robot_id]: {
        ...prevRobots[data.robot_id],
        robotStatus: {
          ...prevRobots[data.robot_id]?.robotStatus,
          ...data,
          timestamp: Date.now()  // Ensuring timestamp is updated
        }
      }
    }));

    // dispatch (updateRobot(robots));
    dispatch(updateRobotStatus(data));

    customLog("Robot pose:", data.pose);
    setPrevRobotPose(curRobotPose);
    setCurRobotPose([data.pose.longitude, data.pose.latitude]);
  }, []);

  useEffect(() => {
    customLog("Robot Jobs:", robots);
    if (selectedRobot3 && selectedRobot3.robotStatus?.robot_id) {
      customLog("Selected Robot:", selectedRobot3);
      setSelectedRobot3(robots[selectedRobot3.robotStatus.robot_id]);
    }

    // update card info
    const totalRobots = Object.keys(robots).length;
    const idleRobots = Object.values(robots).filter(
      robot => availableStatuses.includes(robot.robotStatus?.robot_state?.toLowerCase() || '') && robot.robotStatus?.is_online
    ).length;
    const busyRobots = Object.values(robots).filter(
      robot => !availableStatuses.includes(robot.robotStatus?.robot_state?.toLowerCase() || '') &&
        !robot.robotStatus?.robot_state?.toLowerCase().includes('error') &&
        robot.robotStatus?.is_online
    ).length;
    const offlineRobots = Object.values(robots).filter(robot => !robot.robotStatus?.is_online).length;
    const errorRobots = Object.values(robots).filter(robot => robot.robotStatus?.robot_state?.toLowerCase().includes('error') && robot.robotStatus?.is_online).length;
    setCardInfo({
      totalRobots: { title: "Total Robots", data: totalRobots },
      idleRobots: { title: "Idle", data: idleRobots },
      busyRobots: { title: "Busy", data: busyRobots },
      errorRobots: { title: "Error", data: errorRobots },
      offlineRobots: { title: "Offline", data: offlineRobots }
    });
  }, [robots]);

  useEffect(() => {
    //     customLog("Jobs Dashboard:", jobs);
    if (selectedJob2 && selectedJob2.order_number !== "") {
      customLog("Selected Job:", selectedJob2);
      if (jobs[selectedJob2.order_number]) {
        setSelectedJob2(jobs[selectedJob2.order_number]);
      }
    }
  }, [jobs]);

  useWebSocket(jobOverviewUrl, handleMessage);
  useWebSocket(`${process.env.REACT_APP_WEBSOCKET_URL}/robot/${profile.organisation}/`, handleRobotStatus);

  const contentRef = useRef<HTMLDivElement>(null);
  // const [imageHeight, setImageHeight] = useState<number>(0);
  const imageHeightRef = useRef<number>(0);
  const imageHeight = imageHeightRef.current;
  const setImageHeight = (height: number) => {
    imageHeightRef.current = height;
  };

  const [timeFocused, setTimeFocused] = useState<boolean>(false);
  // const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isPickUpFocused, setIsPickUpFocused] = useQueryState('pickupFocused', parseAsBoolean.withDefault(false));
  const [isDropOffFocused, setIsDropOffFocused] = useQueryState('dropoffFocused', parseAsBoolean.withDefault(false));
  const [_, setIsOpenDeliveryBoard] = useQueryState('isOpenDeliveryBoard', parseAsBoolean.withDefault(false));
  const [fieldCompleted, setFieldCompleted] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [showRobotStatus, setShowRobotStatus] = useState<boolean>(false);

  const [isJobTab, setIsJobTab] = useState<boolean>(false);
  const [showRobotList, setShowRobotList] = useState<boolean>(false);

  const [showGeneralStatus, setShowGeneralStatus] = useState<boolean>(false);
  const [hasMoreRobotJobs, setHasMoreRobotJobs] = useState<boolean>(true);

  const [filterRobot, setFilterRobot] = useQueryState('filterRobot', { defaultValue: '', clearOnDefault: true });

  // const [selectedRobot, setSelectedRobot] = useState<Robot>(new Robot("", initialLatLng, robotDetails));
  const [selectedRobot3, setSelectedRobot3] = useState<RobotInfo | undefined>(undefined);
  // const [selectedRobot3, setSelectedRobot3] = useState<RobotInfo>(defaultRobot);

  const [lastActiveComponent, setLastActiveComponent] = useState('');
  const [searchValue, setSearchValue] = useState("");
  const [searchRobotValue, setSearchRobotValue] = useState("");
  const [form, setForm] = useState<FormDataProps>({
    ...defaultFormValue,
    sender_location: defaultLocation.location_name != undefined ? defaultLocation.location_name : "",
    sender_name: `${profile.username}`,
    robot_id: "",
    timestamp: Date.now(),
    sender_id: `${profile.uuid}`,
    organisation_id: `${profile.organisation}`
  });
  useEffect(() => {
    customLog("default location", defaultLocation);
  }, [defaultLocation]);

  const [selectedJob2, setSelectedJob2] = useState<JobDetails2>(defaultJob);
  const [selectedCleaningJob, setSelectedCleaningJob] = useState<DataCleaningJobType>()
  const [searchResults, setSearchResults] = useState<SearchQuery>({ pickUpResults: [], dropOffResults: [] });
  const [activeStep, setActiveStep] = useState(0);

  const { data: dataMaps, isLoading: isLoadingMap } = useListMap()

  useEffect(() => {
    if (!isOpen) {
      setIsPickUpFocused(false)
      setIsDropOffFocused(false)
    }
    setIsOpenDeliveryBoard(isOpen)
  }, [isOpen])

  useEffect(() => {
    if (showGeneralStatus) {
      setShowRobotList(false);
      setShowRobotStatus(false);
      setIsJobTab(false);
    }

  }, [showGeneralStatus]);

  useEffect(() => {
    if (showRobotList || showRobotStatus || isJobTab) {
      setShowGeneralStatus(false);
    }
    if (isJobTab) {
      getJobList();
    }
  }, [showRobotList, showRobotStatus, isJobTab]);

  const handleShowGeneralStatus = () => {
    setShowGeneralStatus(!showGeneralStatus);
  }


  const handleSelectedJob2 = (job: JobDetails2) => {
    customLog("Selected Job:", job)
    setSelectedJob2(job);
    setSearchResults({ pickUpResults: [], dropOffResults: [] });
    // customLog(job);
    // setIsJobTab(true);

    dispatch(setSelectedJob(job));
    dispatch(setIsJobSelected(true));

    if (showRobotStatus) {
      setShowRobotStatus(false);
      setIsJobTab(true);
      setLastActiveComponent("RobotStatus");
    }
    if (isJobTab) {
      setLastActiveComponent("JobBoard");
    }
  }

  const handleSelectCleaningJob = (job: DataCleaningJobType) => {
    if (!isCleaningMode) {
      return
    }
    setSelectedCleaningJob(job)
    if (showRobotStatus) {
      setLastActiveComponent("RobotStatus");
    }
    if (isJobTab) {
      setLastActiveComponent("JobBoard");
    }
  }

  useEffect(() => {
    if (!selectedCleaningJob) {
      return
    }
    setIsJobTab(true)
    setShowRobotStatus(false);
    setShowGeneralStatus(false)
  }, [selectedCleaningJob])


  useEffect(() => {
    customLog("Selected Job:", selectedJob2);
  }, [selectedJob2]);


  const fuse = new Fuse(listOfLocations2, {
    keys: ['location_name'],
    threshold: 0.3
  });

  const getJobHistory = async (order_number: string) => {
    customLog("Getting jobs history...", order_number);
    if (!accessToken) {
      return;
    }
    await customAxios({
      method: "GET",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/job_logs/?order_number=${order_number}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      customLog(response.data);
      if (response.status === 200) {
        customLog("response history", response.data);
        const dataSortedByDate = response.data.data.sort((a: any, b: any) => b.timestamp - a.timestamp);
        const jobData = dataSortedByDate[0];

        setSelectedJob2(jobData);
        dispatch(setSelectedJob(jobData));
      }
    }
    ).catch((error) => {
      console.error(error);
    });
  }
  const [pendingNotification, setPendingNotification] = useState<{ value: string, type: string } | undefined>(undefined);
  const [isProcessingNotification, setIsProcessingNotification] = useState<boolean>(false);

  useEffect(() => {
    if (!accessToken || !pendingNotification || isProcessingNotification) {
      return
    }
    setIsProcessingNotification(true);
    processNotificationSelection(pendingNotification.value, pendingNotification.type);
    setPendingNotification(undefined);
  }, [localStorage, pendingNotification]);

  const handleNotificationSelection = (value: string, type: string) => {
    dispatch(setNotificationHistoryPanel(false));
    if (accessToken === null || accessToken === undefined) {
      // Handle later after get access token
      setPendingNotification({ value, type });
      return;
    }
    processNotificationSelection(value, type);
  }

  const processNotificationSelection = (value: string, type: string) => {
    dispatch(setNotificationHistoryPanel(false));
    if (type === "job") {
      // const job = jobs[value];
      // setSelectedJob2(job);
      getJobHistory(value);

      // dispatch(setSelectedJob());
      dispatch(setIsJobSelected(true));
      setLastActiveComponent("JobBoard");
      setIsJobTab(true);

      setTimeout(() => {
        dispatch(resetClick());
      }, 300);
    } else if (type === "robot") {
      const robot = robots[value];

      getRobotJobs(value);
      setSelectedRobot3(robot);
      dispatch(setSelectedRobot(robot));
      dispatch(setIsSelectedRobot(true));
      setShowRobotStatus(true);
      setLastActiveComponent("RobotStatus");

      handleSynchronizeMapLevel(robot?.robotStatus?.map_uuid, robot?.robotStatus?.layout_uuid);
      setTimeout(() => {
        dispatch(resetClick());
      }, 300);
    }

    if (pendingNotification?.value === value && pendingNotification?.type === type) {
      setPendingNotification(undefined);
    }
  }

  const handleSynchronizeMapLevel = (map_uuid?: string, layout_uuid?: string) => {
    if (map_uuid && map_uuid !== "" && dataMaps) {
      const listMaps = dataMaps.data || [];
      const mapData = listMaps.find((map: MapDataType) => map.map_uuid === map_uuid || map.map_uuid === layout_uuid);

      if (!mapData) {
        return;
      }

      dispatch(setCurrentFloor(mapData.map_level ? mapData.map_level.toString() : currentFloor));
    }
  }

  const searchLocations = (query: string) => {
    customLog("Searching locations...", form.sender_location, form.recipient_location);
    if (query.length > 0) {
      const results = fuse.search(query);
      const filteredResults = results.map(result => result.item);
      customLog("Filtered results:", filteredResults);
      customLog("Query:", query);
      if (isPickUpFocused) {
        setSearchResults({ pickUpResults: filteredResults, dropOffResults: [] });
        customLog("Pickup focused", filteredResults);

      } else if (isDropOffFocused) {
        setSearchResults({ pickUpResults: [], dropOffResults: filteredResults });
        customLog("Dropoff focused", filteredResults);
      }
    } else {
      if (isPickUpFocused) {
        setSearchResults({ pickUpResults: listOfLocations2, dropOffResults: [] });
      } else if (isDropOffFocused) {
        setSearchResults({ pickUpResults: [], dropOffResults: listOfLocations2 });
      }
    }
  };

  const resetForm = () => {
    // reset form
    const defaultForm: FormDataProps = {
      ...defaultFormValue,
      recipient_name: profile.username,
      compartment_pin: "0000",
      sender_location: defaultLocation.location_name != undefined ? defaultLocation.location_name : "",
      timestamp: Date.now(),
      sender_id: `${profile.uuid}`,
      // sender_id: "",
      recipient_id: "",
      organisation_id: `${profile.organisation}`
    }
    setForm(defaultForm);
  }

  useEffect(() => {
    if (isSubmitted) {
      dispatch(setSenderLocation(""));
      dispatch(setRecipientLocation(""));
      customLog(form, "Form submitted");

      customLog("Resetting form...");
      resetFocus();
      resetForm();
      setFieldCompleted(false);
    }
  }, [isSubmitted]);

  const handleRecipientLocationChange = (value: string, index: number) => {
    customLog("Recipient Location Change", value, index);
    dispatch(updateRecipientLocation({ index, value }));
    searchLocations(value);
  };

  const assignJob = async (event: React.FormEvent<HTMLFormElement>) => {

    customLog("form", form);
    event.preventDefault();
    // let apiURL = `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/job/schedule_robot/`;
    let apiURL = `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/task/delivery/`;
    // let multiDeliveryFlag = false;
    let multiDeliveryFlag = true;
    let multi: { robot_id: string; orders: any[] } = {
      robot_id: form.robot_id,
      orders: []
    }
    if (["later"].includes(form.pickupOption || "") && (!form.time || !form.date)) {
      showErrorToast("Please Select Date & Time to Continue")
      return
    }

    //Check if its not pickup now (select time), then set the timestamp to the selected time
    if (["later"].includes(form.pickupOption || "") && form.time) {
      const dateFormat = "YYYY-MM-DD"
      const date = (form.date || dayjs().format(dateFormat))
      const currentDatetime = dayjs(date + " " + form.time, dateFormat + " " + "HH:mm")

      const isInPast = currentDatetime.isBefore(dayjs().startOf('day'))
      if (isInPast) {
        showErrorToast("Invalid Date & Time Schedule")
        return
      }

      form.timestamp = currentDatetime.unix()
    }
    // if repeat the use recurring jobs
    if (!["", "do_not_repeat"].includes(form.recurring_type)) {
      apiURL = `${API_URL}v1/rms/recurring_job/`
    }

    // if robot id is not null and recipient location is only 1, use assign_robot api else if robot id is not null and recipient location is more that 1 use schedule task api
    if (form.robot_id !== "" && recipient_locations.length === 1) {
      customLog("Assigning job to robot...");
      // old
      // apiURL = `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/job/assign_robot/`;

      //new
      apiURL = `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/task/delivery/`;
    }
    else if (recipient_locations.length > 1) {
      customLog("MultiDelivery task...", recipient_locations);
      multiDeliveryFlag = true;
      apiURL = `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/task/delivery/`;
      // multi = {
      //   robot_id: form.robot_id,
      //   orders: recipient_locations.map((location: string) => {
      //     return {
      //       order_number: "",
      //       recipient_name: form.recipient_name,
      //       recipient_location: location,
      //       compartment_pin: form.compartment_pin,
      //       sender_location: form.sender_location,
      //       sender_name: form.sender_name,
      //       job_type: form.job_type,
      //       robot_id: form.robot_id,
      //       required_compartment: form.required_compartment,
      //       load_compartment: form.required_compartment
      //     }
      //   })
      // }
      customLog("Multi Form:", multi);
    }

    multi = {
      robot_id: form.robot_id,
      orders: recipient_locations.map((location: string) => {
        return {
          order_number: "",
          recipient_name: form.recipient_name,
          recipient_location: location,
          compartment_pin: form.compartment_pin,
          sender_location: form.sender_location,
          sender_name: form.sender_name,
          job_type: form.job_type,
          robot_id: form.robot_id,
          required_compartment: form.required_compartment,
          load_compartment: form.required_compartment
        }
      })
    }
    if (!localStorage.getItem('accessToken')) {
      return;
    }

    if (["later"].includes(form.pickupOption || "") && form.time) {
      const dateFormat = "YYYY-MM-DD"
      const date = (form.date || dayjs().format(dateFormat))
      const currentDatetime = dayjs(date + " " + form.time, dateFormat + " " + "HH:mm")

      const isInPast = currentDatetime.isBefore(dayjs().startOf('day'))
      if (isInPast) {
        showErrorToast("Invalid Date & Time Schedule")
        return
      }
      const timestamp = currentDatetime.unix()

      multi.orders = multi.orders.map((order: any) => ({
        ...order,
        timestamp: timestamp // Convert to seconds for the API,
      }))
    }

    await customAxios({
      method: "POST",
      // url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/order/submit_order/`,
      url: apiURL,
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
      data: multiDeliveryFlag ? multi : form
    })
      .then((response) => {
        customLog(response.data);
        if ([200, 201].includes(response.status)) {
          customLog("starting job", response.data);
          setIsSubmitted(true);
          // setSelectedJob2(response.data);
          // setSelectedJob3(response.data);

          //clear the recipient locations
          recipient_locations.map((location: MapDetails3) => {
            dispatch(deleteRecipientLocation());
          });
          setShowRobotStatus(false);
          setIsJobTab(true);
          // dispatch(setSelectedJob(response.data));
          // dispatch(setIsJobSelected(true));
          setTimeout(() => {
            setIsSubmitted(false);
            dispatch(setFalse());
          }, 5000);
        }
      })
      .catch(function (error) {
        customLog("error", error.response.data);
      });
  }

  const getRecurringJobs = async (pageNumber: number = 1) => {
    if (!localStorage.getItem('accessToken')) {
      return;
    }
    await customAxios({
      method: "GET",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/recurring_job/?page=${pageNumber}&page_size=10`,
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then((response) => {
      customLog(response.data);
      if (response.status === 200) {
        customLog("response recurring jobs", response.data);
        dispatch(setTotalJobNumber(response.data.count));
        dispatch(setTotalPageNumber(response.data.num_pages));
        dispatch(setCurrentPageNumber(response.data.current_page));
        const jobsData = response.data.data.reduce((acc: JobData, job: JobDetails2) => {
          acc[job.order_number] = job;
          return acc;
        }, {});
        customLog("Jobs Data:", jobsData);

        setHasMoreJobs(response.data.current_page < response.data.num_pages)
        if (response.data.current_page > 1) {
          const prevJobData = {
            ...jobs,
            ...jobsData
          }
          setJobs(prevJobData);
          return
        }
        setJobs(jobsData);
      }
    }
    ).catch((error) => {
      console.error(error);
    });
  }


  const queryMapLocations = async () => {
    if (!localStorage.getItem('accessToken')) {
      return;
    }
    await customAxios({
      method: "GET",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/location/?page_size=${DEFAULT_LOCATION_LIMIT}`,
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then((response) => {
      customLog(response.data);
      if (response.status === 200) {
        const filteredLocations = response.data.data.filter((location: MapDetails3) => location.map && location.map.length > 0 && location.pose.latitude !== 0);
        // setListOfLocations(response.data);
        setListOfLocations2(filteredLocations);
        dispatch(storeMapPoints(filteredLocations));
        const getLocationID = profile.location_id;
        const defaultLocation = filteredLocations.filter((location: any) => location.id === getLocationID);
        customLog("Default Location1:", defaultLocation);
        if (defaultLocation.length > 0) {
          setDefaultLocation(defaultLocation[0]);
          setForm(prevForm => ({
            ...prevForm,
            sender_location: defaultLocation[0].location_name
          }));
        }
        // setForm(prevForm => ({
        //     ...prevForm,
        //     sender_location: defaultLocation[0].location_name
        // }));
      }
    }
    ).catch((error) => {
      console.error(error);
    });
  }

  const [profileLoaded, setProfileLoaded] = useState(false);
  useEffect(() => {
    customLog("profile", profile);
    if (profile !== null && profile !== undefined) {
      setProfileLoaded(true);
    }
  }, [profile]);

  const robotJobPageNumber = useSelector((state: any) => state.jobPage.currentRobotJobsPageNumber);

  const getRobotJobs = async (robotId: string, page: number = 1) => {
    try {
      if (!localStorage.getItem('accessToken')) {
        return;
      }
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/v1/rms/assigned_job/?robot_id=${robotId}&page=${page}&page_size=10`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      if (response.status === 200) {
        const newJobs = response.data.data.reduce((acc: JobData, job: JobDetails2) => {
          acc[job.order_number] = job;
          return acc;
        }, {});

        setRobots(prevRobots => ({
          ...prevRobots,
          [robotId]: {
            ...prevRobots[robotId],
            jobs: {
              ...prevRobots[robotId]?.jobs,
              ...newJobs, // Merge new jobs with the existing ones
            },
          },
        }));

        dispatch(setCurrentRobotJobsPageNumber(response.data.current_page));
        dispatch(setTotalRobotJobs(response.data.count));
        dispatch(setTotalRobotJobsPageNumber(response.data.num_pages));
        customLog("fetching robot ", response.data.current_page, response.data.num_pages);
        customLog("fetching robot jobs", response.data.current_page < response.data.num_pages);
        setHasMoreRobotJobs(response.data.current_page < response.data.num_pages);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getRobotStatus = async () => {
    if (!accessToken || !profile.organisation) {
      return;
    }
    await customAxios({
      method: "GET",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/robot_status/?organisation=${profile.organisation}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      customLog(response.data);
      if (response.status === 200) {
        customLog("response robot jobs", response.data);
        response.data.map((robot: any) => {
          setRobots(prevRobots => ({
            ...prevRobots,
            [robot.robot_id]: {
              ...prevRobots[robot.robot_id],
              robotStatus: robot
            },
            // ...mockRobots
          }));
        });

        setRobotStatusQueried(true);
      }
    }
    ).catch((error) => {
      console.error(error);
    });
  }
  const pageNumber = useSelector((state: any) => state.jobPage.currentPageNumber);
  const totalPageNumber = useSelector((state: any) => state.jobPage.totalPageNumber);
  const pageSize = useSelector((state: any) => state.jobPage.jobsPerPage);

  // useEffect(() => {
  //     getJobList();
  // }, [pageNumber]);
  const [hasMoreJobs, setHasMoreJobs] = useState(true);

  const getJobList = async (status = "in_progress", page_to_load = 1) => {
    if (!localStorage.getItem('accessToken')) {
      return;
    }
    setIsLoadingJobs(true);
    customLog("Getting job list...");
    // start_time in unix timestamp at today 12am
    const today_start_time = new Date();
    today_start_time.setHours(0, 0, 0, 0);
    const today_start_time_unix = today_start_time.getTime() / 1000;
    customLog("Today start time:", today_start_time, today_start_time_unix);
    customLog("today start time", `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/assigned_job/?page=${page_to_load}&page_size=10&status=${status}&start_time=${today_start_time_unix}`);

    await customAxios({
      method: "GET",
      url: `${process.env.REACT_APP_SERVER_URL}/api/v1/rms/assigned_job/?page=${page_to_load}&page_size=10&status=${status}&start_time=${today_start_time_unix}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then((response) => {
      setIsLoadingJobs(false);
      customLog(response.data);
      if (response.status === 200) {
        customLog("response", response.data);
        dispatch(setTotalJobNumber(response.data.count));
        dispatch(setTotalPageNumber(response.data.num_pages));
        dispatch(setCurrentPageNumber(response.data.current_page));
        const jobsData = response.data.data.reduce((acc: JobData, job: JobDetails2) => {
          acc[job.order_number] = job;
          return acc;
        }, {});
        customLog("Jobs Data:", jobsData);

        setHasMoreJobs(response.data.current_page < response.data.num_pages)
        if (response.data.current_page > 1) {
          const prevJobData = {
            ...jobs,
            ...jobsData
          }
          setJobs(prevJobData);
          return
        }
        setJobs(jobsData);

        // setTodayJobs(todayJobsData);

        // setListOfLocations(response.data);
        // setListOfLocations2(response.data.data);
        // dispatch(storeMapPoints(response.data.data));
      }
    }
    ).catch((error) => {
      setIsLoadingJobs(false);
      console.error(error);
    });
  }

  const notificationSelected = useSelector((state: any) => state.notification.notificationSelected);


  useEffect(() => {
    if (notificationSelected !== null) {
      customLog("Notification Selected", notificationSelected);
      const meta = JSON.parse(notificationSelected.meta);
      if (notificationSelected.notification_details.notification_type === "job_notification") {
        const order_number = meta.order_number;
        handleNotificationSelection(order_number, "job")

      }
      else if (notificationSelected.notification_details.notification_type === "robot_notification") {
        const robot_id = meta.robot_id;
        handleNotificationSelection(robot_id, "robot");
      }
    }
  }, [notificationSelected]);

  const queryRobots = async () => {
    try {
      // const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/v1/rms/robot/?robot_organisation__uuid=${profile.organisation}`, {
      //     headers: {
      //         "Authorization": `Bearer ${accessToken}`,
      //     },
      // });
      const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/v1/rms/robot/??page_size=1`, {
        headers: {
          "Authorization": `Bearer ${accessToken}`,
        },
      });
      customLog("new robot data", data);
      const robotsData: RobotsData = data.data.reduce((acc: RobotsData, robot: any) => {
        const { robot_mac, robot_name, robot_serial_number, robot_type, organisation, robot_model } = robot;

        // Initialise robot data
        acc[robot_mac] = {
          robotStatus: {
            robot_name: robot_name,
            robot_serial_number: robot_serial_number,
            battery: 0,
            can_assign_job: true,
            is_online: true,
            map: "",
            organisation: organisation,
            pose: {
              latitude: 1.2785387585343386,
              longitude: 103.83483403539259,
              orientation: 0
            },
            robot_id: robot_mac,
            robot_state: "Idle",
            robot_type: robot_type.toString(),
            timestamp: Date.now()
          },
          jobs: {},
          generalInfo: {
            robot_name: robot_name,
            robot_mac: robot_mac,
            robot_serial_number: robot_serial_number,
            robot_type: robot_type.toString(),
            organisation: organisation,
            robot_model: robot_model,
          }
        };
        return acc;
      }, {});

      const totalRobots = Object.keys(robotsData).length;
      setCardInfo({
        totalRobots: { title: "Total Robots", data: totalRobots },
        idleRobots: { title: "Idle", data: 0 },
        busyRobots: { title: "Busy", data: 0 },
        errorRobots: { title: "Error", data: 0 },
        offlineRobots: { title: "Offline", data: 0 }
      });
      setRobotQueried(true);
      dispatch(addRobot(robotsData));

      setRobots(robotsData);

      //Get Latest Robot Status
      getRobotStatus();
    } catch (error) {
      console.error("Failed to fetch robots:", error);
    }
  };

  const [robotQueried, setRobotQueried] = useState<boolean>(false);
  const [robotStatusQueried, setRobotStatusQueried] = useState<boolean>(false);

  useEffect(() => {
    if (!robotStatusQueried) {
      getJobList();
    }
  }, [robotStatusQueried]);

  useEffect(() => {
    // queryMapLocations();
    // queryRobots();
    // getRobotStatus();
    // getJobList();
    // query after profile is loaded
    if (profileLoaded) {
      customLog("Profile loaded", profile);
      queryRobots();
      queryMapLocations();
    }
  }, [profileLoaded]);


  const handleTimeFocus = () => {
    setTimeFocused(true);
  };

  const handleTimeBlur = () => {
    customLog("Time blurred", form.time);
    setTimeFocused(false);
  };

  const handleIsOpen = () => {
    if (isSubmitted) {
      setIsSubmitted(false);
    }
    // setSelectedJob2(defaultJob);
    setIsJobTab(false);
    setShowRobotList(false);
    // When want to close
    if (isOpen) {
      //Reset the Focus state
      resetFocus()
      resetForm()
      dispatch(deleteRecipientLocation())
    }
    dispatch(toggle());
    // setIsOpen(!isOpen);
  }

  const handleStartDeliveryFocus = () => {
    setIsPickUpFocused(true);
    setIsDropOffFocused(false);
    customLog("Pickup focused");
  };

  const handleStartDeliveryBlur = (index: number) => {
    setIsDropOffFocused(true);
    setIsPickUpFocused(false);
    dispatch(updateRecipientIndex(index));
    customLog("Pickup blurred");
  }

  const resetFocus = () => {
    setIsPickUpFocused(false);
    setIsDropOffFocused(false);
  }

  const senderLocation = useSelector((state: any) => state.map.senderLocation);
  const recipientLocation = useSelector((state: any) => state.map.recipientLocation);
  const recipient_locations = useSelector((state: any) => state.form.recipient_locations);

  const handleLocationSelect = useCallback((location: string, deliveryType: string) => {
    // deliveryType === "Pick Up"
    //     ? setForm(prevState => ({ ...prevState, sender_location: location }))
    //     : setForm(prevState => ({ ...prevState, recipient_location: location }));

    if (form.pickupOption === "call_nearest" || form.job_type === "adhoc_job") {
      customLog("form updated 2: ", form);
      setForm(prevState => ({ ...prevState, recipient_location: location }));
      // handleFieldChange("recipient_location", form.recipient_location, currentDropOffIndex);
      // dispatch(callJobAddRecipient(form.sender_location));
    }

    customLog('LOC', location, deliveryType);
    if (deliveryType === "Pick Up") {
      customLog("Updating sender_location in form", location, form.sender_location);
      setForm(prevState => ({ ...prevState, sender_location: location }))
      dispatch(updateField({ name: "sender_location", value: location }));
    } else {
      if (currentDropOffIndex === 0) {
        customLog("Updating recipient_location in form", currentDropOffIndex, location, form.recipient_location);
        setForm(prevState => ({ ...prevState, recipient_location: location }));
      }
      dispatch(updateField({ name: "recipient_location", value: location }));
    }

    if (deliveryType === "Drop Off") {
      customLog("Updating recipient_location in form", currentDropOffIndex, location, form.recipient_location);
      dispatch(updateRecipientLocation({ index: currentDropOffIndex, value: location }));
    }

    resetFocus();

    deliveryType === "Pick Up"
      ? dispatch(setSenderLocation(location))
      : dispatch(setRecipientLocation(location));

    senderLocation !== "" && recipientLocation !== "" ?
      dispatch(setSenderAndRecipientSelected(true))
      : dispatch(setSenderAndRecipientSelected(false));

    if (!isOpen) {
      // setIsOpen(true);
      dispatch(setTrue());
    }
  }, [setForm, resetFocus, isOpen]);

  const handleJobSearchField = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { value } = event.target;
    setSearchValue(value);
  }

  const handleRobotSearchField = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { value } = event.target;
    setSearchRobotValue(value);
  }
  // post to backend
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    customLog("Submitting form...");
    // validate the location before submit
    if (!validateLocations()) {
      return;
    }
    assignJob(event);
  };

  const generalInfo = cardDetails;
  const getNavbarAndCardHeight = (hideCard = false) => {
    const navbarElement = document.querySelector('header.MuiPaper-root')
    if (!navbarElement) {
      return 64
    }

    const cardInfoElement = document.querySelector('.card-info-list')
    const navbarHeight = navbarElement.clientHeight
    const cardInfoHeight = !!cardInfoElement ? cardInfoElement.clientHeight : 0

    const topContentHeight = (isHideCard || hideCard) ? 0 : cardInfoHeight
    return navbarHeight + topContentHeight
  }

  const updateImageHeight = (hideCard = false) => {
    const viewportHeight = window.innerHeight;
    const result = viewportHeight - getNavbarAndCardHeight();

    setImageHeight(result);

    const mapWrapperElement = document.querySelector('.map-wrapper')
    if (!mapWrapperElement) {
      return
    }
    (mapWrapperElement as HTMLElement).style.height = `calc(100vh - ${getNavbarAndCardHeight(hideCard)}px)`
  }

  //location validation
  const isValidLocation = (value: string) => {
    return listOfLocations2.some(
      (location) => location.location_name === value
    );
  };

  const validateLocations = () => {
    const sender = form.sender_location || "";

    if (!sender) {
      showErrorToast("Please enter sender location");
      return false;
    }

    if (!isValidLocation(sender)) {
      showErrorToast("Invalid sender location. Please enter a valid location.");
      return false;
    }

    if (form.pickupOption === "call_nearest" || form.job_type === "adhoc_job") {
      return true;
    }

    const cleanedRecipients = recipient_locations.filter(
      (location: string) => location !== ""
    );

    if (cleanedRecipients.length === 0) {
      showErrorToast("Please enter recipient location");
      return false;
    }

    const invalidRecipient = cleanedRecipients.find(
      (location: string) => !isValidLocation(location)
    );

    if (invalidRecipient) {
      showErrorToast(`Invalid recipient location: ${invalidRecipient}`);
      return false;
    }

    return true;
  };

  useEffect(() => {
    setTimeout(() => {
      updateImageHeight()
    }, 500);
  }, [isHideCard])

  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        updateImageHeight()
      }, 500);
    }
    updateImageHeight();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    customLog("Field change", event.target);
    event.preventDefault();
    let { name, value } = event.target;
    value = name === "time" || name === "robot_id" ? event.target.value : value;
    customLog(name, value, "test");
    setForm(prevState => ({
      ...prevState,
      [name]: ['recurring_days'].includes(name) ? value.split(',') : value
    }));


    if (name === "sender_location" || name === "recipient_location") {
      customLog("Searching locations...");
      searchLocations(value);
    }
  }

  useEffect(() => {
    customLog("Form updated", form);
  }
    , [form]);

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    event.preventDefault();
    const { name, value } = event.target;
    setForm(prevState => ({
      ...prevState,
      [name]: value
    }));
    customLog('SELECT CHANGE', event.target);

  }


  useEffect(() => {
    customLog("Field completed", form);

    if (form.pickupOption === "call_nearest" || (form.sender_location && form.recipient_location)) {
      setFieldCompleted(true);
    }
    else {
      setFieldCompleted(false);
    }
  }, [form.sender_location, form.recipient_location, form.pickupOption]);

  useEffect(() => {
    if (isPickUpFocused || isDropOffFocused) {
      searchLocations("");
    }
  }, [isPickUpFocused, isDropOffFocused]);

  const selectedRobot = useSelector((state: any) => state.robot.selectedRobot);

  const onRobotClick2 = (robot: RobotInfo) => {

    dispatch(setIsSelectedRobot(true));
    dispatch(setSelectedRobot(robot));
    // customLog("Robot clicked", selectedRobot);
    customLog("Robot clicked", robot);
    setSelectedRobot3(robot);
    setShowRobotStatus(true);
    setShowRobotList(false);
    setLastActiveComponent("RobotStatus");
    setIsJobTab(false);
    if (robot.robotStatus?.robot_id) {
      customLog("Getting robot jobs...", robot.robotStatus.robot_id);
      getRobotJobs(robot.robotStatus.robot_id);
    }

    handleChangeMapByRobot(robot)
  }

  const handleChangeMapByRobot = (robot: RobotInfo) => {
    if (!robot.robotStatus || !robot.robotStatus.layout_uuid) {
      return
    }
    const findMap = getMapLevels().find((item) => item.map_uuid === robot.robotStatus?.layout_uuid)
    if (!findMap || !findMap.map_level) {
      return
    }
    const isDifferentLevel = parseInt(currentFloor) !== findMap.map_level
    if (isDifferentLevel) {
      dispatch(setCurrentFloor(findMap.map_level.toString()))
    }
  }

  const filterMapOnly = (data: MapDataType[]) => {
    if (!data || data.length === 0) {
      return []
    }

    return data.filter((item) => item.robot === '' && item.map_longitude_tl > 0 && item.map_latitude_br > 0)
  }

  const getMapLevels = () => {
    if (!dataMaps || isLoadingMap || !dataMaps.data) {
      return [] as MapLevelType[]
    }

    const results: any[] = []
    const notRobotMaps = filterMapOnly(dataMaps.data || []);
    notRobotMaps.map((item) => {
      const find = results.find((result) => result.level === item.map_level)
      if (!find) {
        results.push(item)
      }
    })

    return results
  }

  const robotRef = useRef(robots)
  robotRef.current = robots;

  const onRobotIconClick = (robot: Robot) => {
    if (!robotRef.current) {
      customLog("No robots available");
      return;
    }
    const currentRobot = robotRef.current[robot.robotId];
    dispatch(setIsSelectedRobot(true));
    dispatch(setSelectedRobot(currentRobot));
    setSelectedRobot3(currentRobot);
    setShowRobotStatus(true);
    setShowRobotList(false);
    setIsJobTab(false);
    if (robot.robotId) {
      customLog("Getting robot jobs...", robot.robotId);
      getRobotJobs(robot.robotId);
    }
  }

  const handleJobTab = () => {
    if (showRobotStatus) {
      setShowRobotStatus(false);
      setIsJobTab(true);
      setShowRobotList(false);
      setSelectedRobot3(defaultRobot);
      setLastActiveComponent("RobotStatus");
      setShowRobotList(true);
      dispatch(setIsSelectedRobot(false));
      dispatch(setSelectedRobot(defaultRobot));
    }
    else {
      setShowRobotList(false);
      setIsJobTab(!isJobTab);
      dispatch(setIsJobSelected(false));
      dispatch(setSelectedJob(defaultJob));
    }
  }

  const handleRobotList = () => {
    if (showRobotStatus || isJobTab) {
      setShowRobotStatus(false);
      setSelectedJob2(defaultJob);
      setShowRobotList(true);
      setSelectedRobot3(defaultRobot);
      setIsJobTab(false);
    } else {
      setShowRobotList(!showRobotList);
      setSearchRobotValue("");
    }
  }

  const handleShowRobotList = (key: string) => {
    const lowerKey = key.toLowerCase();
    if (lowerKey.includes('idle')) {
      setFilterRobot('idle');
    } else if (lowerKey.includes('busy')) {
      setFilterRobot('busy');
    } else if (lowerKey.includes('error')) {
      setFilterRobot('error');
    } else if (lowerKey.includes('offline')) {
      setFilterRobot('offline');
    } else {
      setFilterRobot('all');
    }

    setIsJobTab(false);
    setShowRobotList(true);
    setSearchRobotValue("");
  }

  const handleCloseRobotList = () => {
    setShowRobotList(false);
    setSearchRobotValue("");
    if (selectedRobot3?.robotStatus?.robot_id) {
      //reset selected robot
      setSelectedRobot3(defaultRobot);
      // dispatch(resetFloor());
    }
    dispatch(setCurrentRobotJobsPageNumber(1));
  }

  const handleCloseRobotStatus = () => {
    setShowRobotStatus(false);
    if (selectedRobot3?.robotStatus?.robot_id) {
      //reset selected robot
      setSearchRobotValue("");
      setSelectedRobot3(defaultRobot);
      // dispatch(resetFloor());
      dispatch(setIsSelectedRobot(false));
      dispatch(setSelectedRobot(defaultRobot));
      dispatch(setCurrentRobotJobsPageNumber(1));
    }

    setShowRobotList(false);
  }

  const handleJobBoardClose = () => {
    setSearchValue("");
    setIsJobTab(false);
    setSelectedCleaningJob(undefined)
    setSelectedJob2(defaultJob);
    dispatch(setIsJobSelected(false));
    dispatch(setSelectedJob(defaultJob));
    dispatch(setIsSelectedRobot(false));
    dispatch(setCurrentPageNumber(1));
  }

  const handleBackRobotStatus = () => {
    setSearchRobotValue("");
    dispatch(setIsSelectedRobot(false));
    dispatch(setSelectedRobot(defaultRobot));
    setShowRobotStatus(false);
    setSelectedRobot3(defaultRobot);
    setShowRobotList(true);
    dispatch(setCurrentRobotJobsPageNumber(1));
  }

  const handleJobBackButton = () => {
    setSelectedJob2(defaultJob);
    if (lastActiveComponent === "RobotStatus") {
      setShowRobotStatus(true);
      setIsJobTab(false);
    } else {
      setIsJobTab(true);
    }
    dispatch(setIsJobSelected(false));
    dispatch(setSelectedJob(defaultJob));
  }

  const handleDeleteNotification = (order_number: string) => {
    customLog("Deleting notification", order_number);
    const updatedNotificationHistory = { ...dummyNotificationHistory };
    delete updatedNotificationHistory[order_number];
    setDummyNotificationHistory(updatedNotificationHistory);
  }

  const currentFloor = useSelector((state: any) => state.map.currentFloor);
  const floorRef = useRef<string | null>(currentFloor);
  floorRef.current = currentFloor;

  const renderLocationMarkers = useCallback(() => {

    const selectedFloor = floorRef.current || (currentFloor as string)

    // ADD Filter only show the same level
    const listFilter = listOfLocations2.filter((item) => parseInt(item.map[0].map_level?.toString() || '0') === parseInt(selectedFloor))
    if (!isOpen) {
      customLog("Displaying all locations");
      return listFilter.map(location => (
        <LocationMarker
          GIS={[location.pose.longitude, location.pose.latitude]}
          key={location.location_name + '-' + isOpen}
          name={location.location_name}
          x={location.pose.longitude}
          y={location.pose.latitude}
          color="#FF0000"
          selected={false}
        />
      ));
    }
    if (isPickUpFocused) {
      return listFilter.map(location => (
        <LocationMarker GIS={[location.pose.longitude, location.pose.latitude]} key={location.location_name} name={location.location_name} x={location.pose.longitude} y={location.pose.latitude} color="#378FFE" handleLocationSelect={() => handleLocationSelect(location.location_name, "Pick Up")} />
      ));
    } else if (isDropOffFocused) {
      return listFilter.map(location => (
        <LocationMarker GIS={[location.pose.longitude, location.pose.latitude]} key={location.location_name} name={location.location_name} x={location.pose.longitude} y={location.pose.latitude} color="#FF0000" handleLocationSelect={() => handleLocationSelect(location.location_name, "Drop Off")} />
      ));
    } else if (selectedJob2?.sender_location || selectedJob2?.recipient_location) {
      customLog("Selected Job showing", selectedJob2);
      return listOfLocations2.filter(location => location.location_name === selectedJob2.sender_location || location.location_name === selectedJob2.recipient_location).map(location => (
        <LocationMarker GIS={[location.pose.longitude, location.pose.latitude]} key={location.location_name} name={location.location_name} x={location.pose.longitude} y={location.pose.latitude} color={location.location_name === selectedJob2.sender_location ? "#378FFE" : "#FF0000"} selected={true} />
      ));

    } else if (form.sender_location || recipient_locations.length > 0) {
      return listFilter.map(location => (
        <LocationMarker
          GIS={[location.pose.longitude, location.pose.latitude]}
          key={location.location_name}
          name={location.location_name}
          x={location.pose.longitude}
          y={location.pose.latitude}
          // Show Blue color if selected sender and delivery board is open
          color={isOpen && location.location_name === form.sender_location ? "#378FFE" : "#FF0000"}
          // only show big pinpoint when delivery board opened
          selected={isOpen && (form.sender_location === location.location_name || recipient_locations[0] === location.location_name || recipient_locations[1] === location.location_name || recipient_locations[2] === location.location_name)} />
      ));
    } else {
      customLog("Displaying all locations");
      return listOfLocations2.map(location => (
        <LocationMarker GIS={[location.pose.longitude, location.pose.latitude]} key={location.location_name} name={location.location_name} x={location.pose.longitude} y={location.pose.latitude} color="#378FFE" />
      ));
    }

  }, [listOfLocations2, isPickUpFocused, isDropOffFocused, floorRef.current, currentFloor, isOpen]);


  const handleClearTextField = (field: string) => {
    setForm(prevState => ({
      ...prevState,
      [field]: ""
    }));
    resetFocus();
  }

  const handleSetMoreJobs = () => {
    setHasMoreJobs(true);
  }

  const getLines = (): [number, number][] => {
    // check if there is a selected job with both pick-up and drop-off locations
    // customLog("Selected Job 34:", selectedJob2);
    if (selectedJob2?.order_number !== "" && selectedJob2?.sender_location && selectedJob2?.recipient_location) {
      const selectedPickUpLocation = listOfLocations2.find(loc => loc.location_name === selectedJob2.sender_location);
      const selectedDropOffLocation = listOfLocations2.find(loc => loc.location_name === selectedJob2.recipient_location);
      if (selectedPickUpLocation && selectedDropOffLocation) {
        customLog("Displaying line for selected job:", selectedJob2, selectedPickUpLocation, selectedDropOffLocation);
        return [[selectedPickUpLocation.pose.longitude, selectedPickUpLocation.pose.latitude], [selectedDropOffLocation.pose.longitude, selectedDropOffLocation.pose.latitude]];
        // return [selectedPickUpLocation.GIS, selectedDropOffLocation.GIS];
      }
    }

    // check if the form's pick-up and drop-off fields are filled and no selected job is active
    if (form.sender_location && form.recipient_location && !selectedJob2.order_number) {
      customLog("updating line for form data:", form);
      const pickUpLocation = listOfLocations2.find(loc => loc.location_name === form.sender_location);
      const dropOffLocation = listOfLocations2.find(loc => loc.location_name === form.recipient_location);

      // Handle if recipient location is more than 1 location
      if (pickUpLocation && recipient_locations && recipient_locations.length > 1) {
        const destinations = recipient_locations.map((name: string) => {
          const loc = listOfLocations2.find(loc => loc.location_name === name);
          return loc ? [loc.pose.longitude, loc.pose.latitude] as [number, number] : null;
        }).filter((item: any) => item !== null);

        // Start Location
        const pickUpGIS = [pickUpLocation.pose.longitude, pickUpLocation.pose.latitude] as [number, number];

        return [
          pickUpGIS,
          ...destinations
        ]
      }
      if (pickUpLocation && dropOffLocation) {
        customLog("Displaying line for form data:", pickUpLocation, dropOffLocation);
        const pickUpGIS = [pickUpLocation.pose.longitude, pickUpLocation.pose.latitude] as [number, number];
        const dropOffGIS = [dropOffLocation.pose.longitude, dropOffLocation.pose.latitude] as [number, number];
        // return [pickUpLocation.GIS, dropOffLocation.GIS];
        return [pickUpGIS, dropOffGIS];
      }
    }

    // If no conditions are met, return an empty array
    customLog("No valid data for displaying line");
    return [];
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  }

  const notificationHistoryPanel = useSelector((state: any) => state.notification.notificationHistoryPanel);

  /** Handler when Open Delivery Board,
   * If sender_location exist then select sender_location floor level
   *  */
  useEffect(() => {
    if (!isOpen || !form.sender_location) {
      return
    }

    const pickUpLocation = listOfLocations2.find(loc => loc.location_name === form.sender_location);
    if (!pickUpLocation || !pickUpLocation.map || !pickUpLocation.map[0].map_level) {
      return
    }

    const isDifferentLevel = parseInt(currentFloor) !== pickUpLocation.map[0].map_level
    if (isDifferentLevel) {
      dispatch(setCurrentFloor(pickUpLocation.map[0].map_level.toString()))
    }
  }, [isOpen])

  // const [isHideCard, setIsHideCard] = useQueryState("hideCard", parseAsBoolean.withDefault(false).withOptions({ clearOnDefault: true }));

  const handleHideCard = () => {
    updateImageHeight(!isHideCard);
    setIsHideCard(!isHideCard);
  }

  const handleOpenCleaningDialog = () => {
    setIsCleaningDialogOpen(true);
  }

  const [, setCoordinates] = useQueryStates(
    {
      // Use variable names that make sense in your codebase
      latitude: parseAsFloat.withDefault(0).withOptions({ clearOnDefault: true }),
      longitude: parseAsFloat.withDefault(0).withOptions({ clearOnDefault: true }),
    },
    {
      urlKeys: {
        // And remap them to shorter keys in the URL
        latitude: MAP_FLYTO_LAT_QUERY_PARAM,
        longitude: MAP_FLYTO_LNG_QUERY_PARAM
      }
    }
  )

  const handleOpenDeliveryDialog = () => {
    handleIsOpen()
  }

  const handleMapFlyTo = (longitude: number, latitude: number) => {
    setCoordinates({ latitude, longitude });
  }

  const handleSuccessCleaning = () => {
    setShowRobotStatus(false);
    setIsJobTab(true);
    // TODO: Adjust selected job tab after cleaning success
    setSelectedJob2({
      ...defaultJob,
      order_number: 'MOE0002',
      job_type: JOB_TYPE.CLEANING,
      job_status: JobEnums.IN_PROGRESS
    });
  }

  useEffect(() => {
    if (!isJobTab) {
      setShowZone(false)
      setSelectedZones([]);
    }
  }, [isJobTab]);

  useEffect(() => {
    if (dashboardMode === DashboardMode.DELIVERY) {
      updateImageHeight(false);
      return
    }
    if (dashboardMode === DashboardMode.CLEANING) {
      setIsHideCard(true);
      updateImageHeight(true);
    }
  }, [dashboardMode])

  useDisableTabKey()

  const getMainColor = () => {
    if (isCleaningMode) {
      return COLOR.cleaningMain
    }
    return COLOR.deliveryMain
  }
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', color: "white", margin: 0, width: "100%", background: "#f6f7f6", overflow: "hidden" }}>
      <div ref={contentRef} style={{ flex: 'none' }} className="card-info-list">
        <Stack
          direction="column"
          spacing={2}
          sx={(theme) => ({
            [theme.breakpoints.up(VIEW.PHONE)]: {
              height: isHideCard ? "0px" : "80px",
            },
            [theme.breakpoints.up(VIEW.TABLET)]: {
              height: isHideCard ? "0px" : "100px",
            },
            [theme.breakpoints.up(VIEW.DESKTOP)]: {
              height: isHideCard ? "0px" : "120px",
            },
            transition: "all 0.3s ease",
            width: "100%",
            margin: "auto",
            display: "flex",
            background: `linear-gradient(to bottom, ${getMainColor()}, #F8F7F7)`,
            alignItems: "center",
            justifyContent: "center",
            pt: isHideCard ? "0px" : 1
          })}>
          <Grid container spacing={2} sx={{ display: "flex", width: "97%", }}>
            {/* {cardInfo.map((item, index) => (
                            <AggregateCard key={index} title={item.title} data={item.data} clicked={false} />
                        ))} */}
            {cardInfo && Object.keys(cardInfo).map((key, index) => (
              <AggregateCard
                key={index}
                title={cardInfo[key].title}
                data={cardInfo[key].data}
                clicked={false}
                onClick={() => handleShowRobotList(key)}
              />
            ))}
          </Grid>
        </Stack>
      </div>
      <Stack direction="column" spacing={2} >
        <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
          <Box
            onClick={handleHideCard}
            sx={(theme) => ({
              [theme.breakpoints.up(VIEW.PHONE)]: {
                top: '46px',
              },
              [theme.breakpoints.up(VIEW.TABLET)]: {
                top: 0
              },
              [theme.breakpoints.up(VIEW.DESKTOP)]: {
                top: 0,
                opacity: 0,
                '&:hover': {
                  opacity: 1
                },
                transition: 'opacity 0.3s ease',
              },
              position: 'absolute',
              left: 'calc(50% - 50px)',
              right: 'calc(50% - 50px)',
              width: '80px',
              height: 'auto',
              padding: '8px',
              color: COLOR.black,
              backgroundColor: COLOR.white,
              zIndex: 1000,
              display: 'flex',
              justifyContent: 'center',
              borderBottomLeftRadius: '8px',
              borderBottomRightRadius: '8px',
              cursor: 'pointer',
              alignItems: 'center',
              ...shadow
            })}>
            <KeyboardDoubleArrowDown sx={{
              rotate: isHideCard ? '0deg' : '180deg',
              transition: 'transform 0.3s ease'
            }} />
          </Box>

          {!isCleaningDialogOpen && (
            <>
              <Stack
                sx={(theme) => ({
                  [theme.breakpoints.up(VIEW.PHONE)]: {
                    right: "15px",
                    left: "15px",
                    top: "10px",
                    // maxWidth: '330px',
                    mx: 'auto'
                  },
                  [theme.breakpoints.up(VIEW.TABLET)]: {
                    left: "auto",
                    marginLeft: 'auto',
                    right: "20px",
                    top: "10px",
                    maxWidth: '340px',
                  },
                  [theme.breakpoints.up(VIEW.DESKTOP)]: {
                    left: "auto",
                    marginLeft: 'auto',
                    top: "10px"
                  },
                  position: "absolute",
                  display: "flex",
                  flexDirection: "row",
                  bgcolor: "white",
                  padding: "8px",
                  borderRadius: "4px",
                  alignContent: 'center',
                  px: 2,
                  zIndex: 1000,
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.13)",
                })}>
                <Typography sx={(theme) => ({
                  [theme.breakpoints.up(VIEW.PHONE)]: {
                    fontSize: "12px",
                  },
                  [theme.breakpoints.up(VIEW.TABLET)]: {
                    fontSize: "14px",
                  },
                  mr: 3,
                  flex: 'auto',
                  textAlign: 'center',
                  color: showGeneralStatus ? "#378FFE" : "#9E9E9E",
                  // textShadow: `-1px -1px 0 #B0B0B0, 1px -1px 0 #B0B0B0, -1px 1px 0 #B0B0B0, 1px 1px 0 #B0B0B0`,
                  '&:hover': { cursor: "pointer", color: "#378FFE" }
                })}
                  onClick={handleShowGeneralStatus}>
                  Lift Status
                </Typography>
                <Divider orientation="vertical" sx={{ height: "20px", color: "#9E9E9E", mr: 3 }} />

                <Typography
                  sx={(theme) => ({
                    [theme.breakpoints.up(VIEW.PHONE)]: {
                      fontSize: "12px",
                    },
                    [theme.breakpoints.up(VIEW.TABLET)]: {
                      fontSize: "14px",
                    },
                    mr: 3,
                    flex: 'auto',
                    textAlign: 'center',
                    color: showRobotList ? "#378FFE" : "#9E9E9E",
                    // textShadow: `-1px -1px 0 #B0B0B0, 1px -1px 0 #B0B0B0, -1px 1px 0 #B0B0B0, 1px 1px 0 #B0B0B0`,
                    '&:hover': { cursor: "pointer", color: "#378FFE" }
                  })
                  }
                  onClick={handleRobotList}>
                  Robot Status
                </Typography>
                <Divider orientation="vertical" sx={{ height: "20px", color: "#9E9E9E", mr: 3 }} />

                <Typography sx={(theme) => ({
                  [theme.breakpoints.up(VIEW.PHONE)]: {
                    fontSize: "12px",
                  },
                  [theme.breakpoints.up(VIEW.TABLET)]: {
                    fontSize: "14px",
                  },
                  // fontWeight:"600",
                  flex: 'auto',
                  textAlign: 'center',
                  color: isJobTab ? "#378FFE" : "#9E9E9E",
                  // textShadow: `-1p x -1px 0 #B0B0B0, 1px -1px 0 #B0B0B0, -1px 1px 0 #B0B0B0, 1px 1px 0 #B0B0B0`,
                  '&:hover': { cursor: "pointer", color: "#378FFE" }
                })}
                  onClick={handleJobTab}>
                  Today's Jobs
                </Typography>
              </Stack>
              {showRobotStatus && selectedRobot3 && (
                <RobotStatus key={'robot-status'} showRobotStatus={showRobotStatus} handleSelectCleaningJob={handleSelectCleaningJob} handleSelectedJob={handleSelectedJob2} robotInfo={selectedRobot3 ?? {}} handleCloseTab={handleCloseRobotStatus} handleBackButton={handleBackRobotStatus} getRobotJobs={getRobotJobs} hasMoreRobotJobs={hasMoreRobotJobs} />
              )}

              {showRobotList && (
                <RobotList key={'robot-list'} showRobotList={showRobotList} handleRobotList={handleRobotList} onRobotSelect={(robot: RobotInfo) => onRobotClick2(robot)} robots={robots} handleCloseRobotList={handleCloseRobotList} searchRobotValue={searchRobotValue} handleSearchRobotField={handleRobotSearchField} />
              )}
              {/* {showGeneralStatus && ( */}
              <GeneralStatus isOpen={showGeneralStatus} key={'general-status'} handleStatusBoardClose={handleShowGeneralStatus} />
              {/* )} */}
              {isJobTab && !isCleaningMode && (<JobBoard isLoadingJobs={isLoadingJobs} robotLists={robots} getRecurringJobs={getRecurringJobs} handleSetMoreJobs={handleSetMoreJobs} hasMoreJobs={hasMoreJobs} getJobList={getJobList} handleJobBoardClose={handleJobBoardClose} handleSelectedJob={handleSelectedJob2} selectedJob={selectedJob2} imageHeight={imageHeight} activeStep={activeStep} handleJobSearchField={handleJobSearchField} searchValue={searchValue} listOfJobs={jobs} handleBackButton={handleJobBackButton} />)}
              {isJobTab && isCleaningMode && (
                <CleaningJobBoard defaultSelectedCleaningJob={selectedCleaningJob} handleJobBoardClose={() => handleJobBoardClose()} />
              )}
            </>
          )}
          <Box
            sx={{
              width: "100%",
              margin: "auto",
              height: `calc(100vh - ${getNavbarAndCardHeight() + 'px'})`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
            className="map-wrapper"
          >
            <RobotMapContainer mapHeight={imageHeight} onRobotClick={onRobotIconClick} line={getLines()} movement={[prevRobotPose, curRobotPose]} robotData={robots} renderLocationMarkers={renderLocationMarkers} >
              {renderLocationMarkers()}
            </RobotMapContainer>

          </Box>


          {isCleaningDialogOpen && isCleaningMode && (
            <CleaningDialog
              open={isCleaningDialogOpen}
              handleClose={() => {
                setIsCleaningDialogOpen(false);
                setShowZone(false);
                setSelectedZones([])
              }}
              handleCloseSuccess={() => {
                setIsCleaningDialogOpen(false);
              }}
              onMapFlyToZone={(lng, lat) => handleMapFlyTo(lng, lat)}
              onSuccess={handleSuccessCleaning}
              mapLevels={getMapLevels()}
            />
          )}
        </div>
        {isOpen && isDeliveryMode && (
          <DeliveryBoard
            timeFocused={timeFocused}
            handleTimeFocus={handleTimeFocus}
            handleTimeBlur={handleTimeBlur}
            handleIsOpen={handleIsOpen}
            handleStartDeliveryFocus={handleStartDeliveryFocus}
            handleStartDeliveryBlur={(index: number) => handleStartDeliveryBlur(index)}
            isPickUpFocused={isPickUpFocused}
            isDropOffFocused={isDropOffFocused}
            resetFocus={resetFocus}
            handleLocationSelect={handleLocationSelect}
            fieldCompleted={fieldCompleted}
            isSubmitted={isSubmitted}
            handleSubmit={handleSubmit}
            form={form}
            handleFieldChange={handleFieldChange}
            handleSelectChange={handleSelectChange}
            handleClearTextField={handleClearTextField}
            robots={robots}
            maps={isPickUpFocused ? searchResults.pickUpResults : isDropOffFocused ? searchResults.dropOffResults : listOfLocations2}
            handleRecipientLocationChange={handleRecipientLocationChange}
          />
        )}

      </Stack>


      {!isOpen && isDeliveryMode && (
        // <Stack
        //   sx={(theme) => ({
        //     [theme.breakpoints.up(VIEW.PHONE)]: {
        //       bottom: "25px",
        //       left: "15px",
        //     },
        //     [theme.breakpoints.up(VIEW.DESKTOP)]: {
        //       bottom: "30px",
        //       left: "40px",
        //     },
        //     position: "absolute",
        //     zIndex: 1000
        //   })}>
        //   <Button variant="contained" sx={{ width: "62px", height: "62px", bgcolor: "#2C8DFF", color: "white", fontWeight: "600", borderRadius: "31px", boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }} onClick={handleIsOpen}>
        //     <img src={parcel} style={{ width: "30px", height: "30px" }} />
        //   </Button>
        // </Stack>
        <Stack
          sx={(theme) => ({
            [theme.breakpoints.up(VIEW.PHONE)]: {
              bottom: "25px",
              left: "15px",
            },
            [theme.breakpoints.up(VIEW.DESKTOP)]: {
              bottom: "25px",
              left: "50px",
            },
            position: "absolute",
            zIndex: 1000
          })}>
          <Button
            variant="contained"
            sx={(theme) => ({
              [theme.breakpoints.up(VIEW.DESKTOP)]: {
                paddingBlock: '16px',
              },
              [theme.breakpoints.up(VIEW.TABLET)]: {
                fontSize: '24px',
                width: "300px",
                height: "auto"
              },
              width: "180px",
              height: "62px",
              paddingBlock: '10px',
              bgcolor: "#2C8DFF",
              color: "white",
              fontWeight: "600",
              borderRadius: "8px",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              fontSize: '16px',
              textTransform: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            })}
            onClick={handleOpenDeliveryDialog}>
            <Box sx={(theme) => ({
              [theme.breakpoints.up(VIEW.TABLET)]: {
                width: '36px',
              },
              mr: '8px',
              display: 'flex',
              width: '32px',
              alignItems: 'center',
              justifyContent: 'center',

            })}>
              <img width={'100%'} src={parcel} alt="Sweeping Icon" />
            </Box>
            Start Delivery
          </Button>
        </Stack>
      )}

      {!isCleaningDialogOpen && isCleaningMode && (
        <Stack
          sx={(theme) => ({
            [theme.breakpoints.up(VIEW.PHONE)]: {
              bottom: "25px",
              left: "15px",
            },
            [theme.breakpoints.up(VIEW.DESKTOP)]: {
              bottom: "25px",
              left: "50px",
            },
            position: "absolute",
            zIndex: 1000
          })}>
          <Button
            variant="contained"
            sx={(theme) => ({
              [theme.breakpoints.up(VIEW.DESKTOP)]: {
                paddingBlock: '16px',
              },
              [theme.breakpoints.up(VIEW.TABLET)]: {
                fontSize: '24px',
                width: "300px",
                height: "auto",
                paddingInline: "16px"
              },
              paddingInline: "8px",
              width: "180px",
              height: "62px",
              paddingBlock: '10px',
              bgcolor: "#2C8DFF",
              color: "white",
              fontWeight: "600",
              borderRadius: "8px",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              fontSize: '16px',
              textTransform: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            })}
            onClick={handleOpenCleaningDialog}>
            <Box sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              [theme.breakpoints.up(VIEW.TABLET)]: {
                width: "56px",
                mr: '8px',
              },
              mr: '4px',
              width: '42px'
            })}>
              <img width={'100%'} src={SweepingIcon} alt="Sweeping Icon" />
            </Box>
            Start Cleaning
          </Button>
        </Stack>
      )
      }
      <Stack
        direction={"column"}
        sx={(theme) => ({
          [theme.breakpoints.up(VIEW.PHONE)]: {
            left: "15px",
            bottom: "140px",
          },
          [theme.breakpoints.up(VIEW.DESKTOP)]: {
            left: "50px",
            bottom: "150px",
          },
          zIndex: 1000,
          position: "absolute",
          width: "40px",
          height: "40px",
        })}>
        {/* <Button sx={{minWidth:"40px", minHeight:"40px", bgcolor: "rgba(187, 187, 187, 0.5)", color: "white", fontWeight:"600", borderRadius:"4px", fontSize:"16px", mb:0.2, '&:hover': { cursor:"pointer", bgcolor:"rgba(96, 96, 96, 0.62)" } }} onClick={() => {
                        dispatch(toggleLegend());
                        customLog("toggling legend, ", legendOpen);

                    }}>
                        <LegendToggleIcon />
                    </Button> */}
        <Button sx={{ minWidth: "40px", minHeight: "40px", bgcolor: "rgba(187, 187, 187, 0.5)", color: "white", fontWeight: "600", borderRadius: "4px", fontSize: "16px", mb: 0.2, '&:hover': { cursor: "pointer", bgcolor: "rgba(96, 96, 96, 0.62)" } }} onClick={() => dispatch(zoomIn())}>
          +
        </Button>
        <Button sx={{ minWidth: "40px", minHeight: "40px", bgcolor: "rgba(187, 187, 187, 0.5)", color: "white", fontWeight: "600", borderRadius: "4px", fontSize: "16px", '&:hover': { cursor: "pointer", bgcolor: "rgba(96, 96, 96, 0.62)" } }} onClick={() => dispatch(zoomOut())}>
          -
        </Button>

      </Stack>
      {/* { isNotificationOn ?
                <>
                    <Notification/>
                    <audio ref={audioRef} src={audioSrc} autoPlay />
                </>
                : null
            } */}
      <FireAlarmModal />
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      {/* <NotificationHistoryPanel handleNotificationSelection={handleNotificationSelection} open={notificationHistoryPanel}  dummyNotificationHistory={dummyNotificationHistory} handleSelectJob={handleSelectedJob2} handleDeleteNotification={handleDeleteNotification} /> */}
      <NotificationHistoryPanel
        open={notificationHistoryPanel}
        dummyNotificationHistory={{}}
        handleSelectJob={handleSelectedJob2}
        handleDeleteNotification={handleDeleteNotification}
      // handleNotificationSelection={handleNotificationSelection}
      />

    </div >
  );
}

export default Dashboard;
